import { useEffect, useState, useRef } from "react";
import { Progress, Typography } from "antd";
import { AlertOutlined, WarningOutlined } from "@ant-design/icons";
import { COLORS, Typo } from "../../layout/theme";
const { Text } = Typography;

const FakeProgress = ({ isLoading, title }) => {
	const [percent, setPercent] = useState(0);
	const intervalRef = useRef(null);

	const getStepMessage = (percent) => {
		if (percent < 30) return "Validando distribuidores...";
		if (percent < 60) return "Verificando productos y descuentos...";
		if (percent < 90) return "Creando órdenes...";
		return "Finalizando...";
	};

	useEffect(() => {
		if (isLoading) {
			setPercent(0);
			clearInterval(intervalRef.current);

			intervalRef.current = setInterval(() => {
				setPercent((prev) => {
					if (prev >= 90) {
						clearInterval(intervalRef.current);
						return prev;
					}
					return prev + 1;
				});
			}, 5000);
		} else {
			clearInterval(intervalRef.current);
			setPercent(100);
			setTimeout(() => setPercent(0), 1000);
		}

		return () => clearInterval(intervalRef.current);
	}, [isLoading]);

	return isLoading || percent === 100 ? (
		<div style={{ marginTop: 16 }}>
			<Typo level={5} style={{ marginBottom: 12 }}>
				{title}
			</Typo>

			<Progress percent={percent} status="active" />

			<Typo type="danger" style={{ display: "block", marginTop: 12 }}>
				<WarningOutlined style={{ color: COLORS.Danger }} /> No cerrar ni
				recargar la página durante este proceso. Podrías perder información.
			</Typo>

			<Text type="secondary" style={{ display: "block", marginTop: 10 }}>
				{getStepMessage(percent)}
			</Text>
		</div>
	) : null;
};

export default FakeProgress;
